<template>
  <AnfrageWizardNewComponent :slug="$route.params.slug"
                             type="slug"></AnfrageWizardNewComponent>
</template>

<script>
  import AnfrageWizardNewComponent from '~/components/anfragen/wizards/AnfrageWizardNewComponent'

  export default {
    name: 'wizard',
    components: {
      AnfrageWizardNewComponent
    },
    data () {
      return {
      }
    }
  }
</script>


